import { type UseQueryResult, useQuery } from 'react-query';
import {
  EsppPptPurchasePeriodService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptPurchasePeriodDetailVm,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetParticipantEsppOfferingPeriodDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptPurchasePeriodDetailVm | undefined,
  unknown
> => {
  const participantEsppOfferingPeriodDetails = useQuery(
    ['getParticipantEsppOfferingPeriodDetails'],
    async () => {
      if (id) {
        return await handleRequest(
          EsppPptPurchasePeriodService.getApiAwardApiPptEsppPurchasePeriod1(id)
        );
      }
    }
  );

  return participantEsppOfferingPeriodDetails;
};

export default useGetParticipantEsppOfferingPeriodDetails;
